import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPreferences = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={32}
    height={32}
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={2}>
      <rect width={22} height={7.771} x={5} y={5} rx={3.886} />
      <rect width={7} height={7.771} x={5} y={5} rx={3.5} />
      <rect width={22} height={7.771} x={5} y={19.229} rx={3.886} />
      <rect width={7} height={7.771} x={20} y={19.229} rx={3.5} />
    </g>
  </svg>
);
export default SvgIcPreferences;
